import * as React from "react";
import { memo } from "react";
const SvgChevronLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.375 18.75L8.625 12L15.375 5.25", stroke: "currentColor", strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: "square" }));
const Memo = memo(SvgChevronLeft);
export default Memo;
